import React from 'react';

const InfoCircleIcon: React.FC = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#FEF0C7" />
    <rect x="4" y="4" width="48" height="48" rx="24" stroke="#FFFAEB" strokeWidth="8" />
    <g clipPath="url(#clip0_34844_109304)">
      <path
        d="M27.9998 31.3334V28.0001M27.9998 24.6667H28.0082M36.3332 28.0001C36.3332 32.6025 32.6022 36.3334 27.9998 36.3334C23.3975 36.3334 19.6665 32.6025 19.6665 28.0001C19.6665 23.3977 23.3975 19.6667 27.9998 19.6667C32.6022 19.6667 36.3332 23.3977 36.3332 28.0001Z"
        stroke="#F79009"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_34844_109304">
        <rect width="20" height="20" fill="white" transform="translate(18 18)" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoCircleIcon;
